import { useLocalObservable } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';

import { IEditProfileFormData } from './EditProfileForm/EditProfileForm.presenter';

interface IEditProfilePopupPresenter {
  hasBackButton: boolean;
  submit(data: IEditProfileFormData): Promise<void>;
  onClose(): void;
  onBack(): void;
}

export function useEditProfilePopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps): IEditProfilePopupPresenter {
  const { t } = useTranslation();

  return useLocalObservable<IEditProfilePopupPresenter>(() => ({
    get hasBackButton(): boolean {
      return !!onBack;
    },

    async submit(data: IEditProfileFormData): Promise<void> {
      const success = await Tasks.userSettings.updateMyProfileB2B(data);

      if (!success) {
        Tasks.app.showToast(t('something_went_wrong'));
      }

      this.onBack();
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));
}
